(function () {
    'use strict';

    // @ngInject
    function HomeManagerCtor($q, APIService, Routes, CompaniesManager, ModelFactory) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);

        this.Routes = Routes;
    }

    Services.HomeManager = Class(Services.BaseModelManager, {
        constructor: HomeManagerCtor,

        getHomebookkeeping: function getHomebookkeeping() {
            var url = this.Routes.v2_get_home_bookkeeping_path();
            return this.apiFetch(url);
        },

        getCalendar: function getCalendar() {
            var url = this.Routes.v2_get_home_calendar_path();
            return this.apiFetch(url);
        },

        getRecentActivity: function getRecentActivity() {
            var url = this.Routes.v2_get_home_recent_activity_path();
            return this.apiFetch(url);
        }
    });

}());